module.exports = __webpack_public_path__ + "static/media/card-blog6.7e4fdf9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/card-blog6.jpg
// module id = 778
// module chunks = 0